<template>
  <div class="animated fadeIn data-grid">
    <div class="paging-container paging-top">
      <div class="total-items paging-total">
        Total: <span>{{ formatThousandDecimal(total) }}</span>
      </div>
      <div class="dt-paging paging-control">
        <div class="select-page-number">
          <b-pagination
            @change="changePageOptions"
            size="md"
            :total-rows="total"
            :value="pagingObj.page"
            :per-page="parseInt(pagingObj.limit)"
          >
          </b-pagination>
        </div>
        <b-form-group
          horizontal
          :label-cols="6"
          label="Per page"
          class="item-per-page"
        >
          <b-form-select
            @change="changeItemPerPageOptions"
            :options="pageOptions"
            v-model="pagingObj.limit"
          />
        </b-form-group>
      </div>
    </div>
    <div class="datatable-table-wrapper table-responsive">
      <b-table
        outlined
        hover
        no-local-sorting
        class="datatable-table"
        :per-page="parseInt(pagingObj.limit)"
        :items="items"
        :fields="fields"
        :id="id"
        :sort-icon-left="sortIconLeft"
        @row-clicked="$emit('table-row-clicked', $event)"
        @sort-changed="sortingChanged"
      >
        <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
          <slot :name="slotName" v-bind="scope"/>
        </template>
      </b-table>
    </div>
    <div
      v-if="items.length === 0 && showNoRecordMessage"
      class="text-center mb-4"
    >
      <span>No record(s) returned, please enter new search criteria</span>
    </div>
    <div class="paging-container paging-bottom">
      <div class="dt-paging paging-control">
        <div class="select-page-number">
          <b-pagination
            @change="changePageOptions"
            size="md"
            :total-rows="total"
            v-model="pagingObj.page"
            :per-page="parseInt(pagingObj.limit)"
          >
          </b-pagination>
        </div>
        <b-form-group
          horizontal
          :label-cols="6"
          label="Per page"
          class="item-per-page"
        >
          <b-form-select
            @change="changeItemPerPageOptions"
            :options="pageOptions"
            v-model="pagingObj.limit"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * TODO should combine with Table when refactor table list
 * TODO should display state loading, empty.
 * Display list of data as table that includes paging, item per page.
 * @events datatable-change(params, isFirstMounted)
 */
export default {
  name: "data-table",
  components: {},
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    pageOptions: {
      type: Array,
      default: () => [5, 10, 15, 20, 25, 50, 100]
    },
    total: {
      type: Number,
      default: 0
    },
    sortedBy: {
      type: String,
      default: () => "asc"
    },
    id: {
      type: String,
      default: ""
    },
    showNoRecordMessage: {
      type: Boolean,
      default: false
    },
    sortIconLeft: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      ctx: null,
      pagingObj: {
        page: 1,
        orderBy: "",
        sortedBy: this.sortedBy,
        total: this.total,
        searchJoin: "and",
        limit: parseInt(this.$route.query.limit || 25)
      }
    };
  },
  methods: {
    formatThousandDecimal(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeItemPerPageOptions(value) {
      this.pagingObj.limit = value;
      this.pagingObj.page = 1;
      this.changeDataTableParams();
    },
    changePageOptions(value) {
      this.pagingObj.page = value;
      this.changeDataTableParams();
    },
    sortingChanged(ctx) {
      this.ctx = ctx;
      this.changeDataTableParams();
    },
    changeDataTableParams() {
      this.$emit("datatable-change", this.getDataTableParams(), false);
    },
    getSortedByValue(sortDesc) {
      return sortDesc ? "desc" : "asc";
    },
    getDataTableParams() {
      let pagingObject = Object.assign(
        {},
        ...Object.keys(this.pagingObj).map(k =>
          this.pagingObj[k] !== "" ? { [k]: this.pagingObj[k] } : {}
        )
      );
      const orderBy = this.ctx && this.ctx.sortBy;
      const sortedBy = this.ctx
        ? this.getSortedByValue(this.ctx && this.ctx.sortDesc)
        : this.sortedBy;
      return Object.assign(
        { ...pagingObject, sortedBy },
        orderBy && { orderBy }
      );
    }
  },
  beforeMount() {
    this.$emit("datatable-change", this.getDataTableParams(), true);
  },
  watch: {
    $route(newRoute) {
      this.pagingObj = Object.assign(this.pagingObj, {
        ...newRoute.query,
        page: parseInt(newRoute.query.page || 1)
      });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/_core-variables.scss";
.data-grid {
  padding-top: 15px;
  border-radius: 0 0 4px 4px;
  .datatable-table-wrapper {
    display: inline-block;
    width: 100%;
    overflow: visible;
    position: relative;
    z-index: 2;
    .datatable-table {
      .action-icon {
        button {
          padding-top: 0;
          padding-bottom: 0;
          text-decoration: none;
        }
        .dropdown-menu {
          border-radius: 4px;
          background-color: $white;
          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.5),
            0 2px 3px 0 rgba(0, 0, 0, 0.15);
          color: $near-black;
          font-size: 0.75rem;
          line-height: 1.5rem;
        }
        .icon-action-more {
          color: $near-black;
          &:before {
            display: inline-block;
            content: "";
            background: url("../../assets/icons/icon-action-more.svg") no-repeat;
            height: 0.4375rem;
            width: 1.813rem;
            position: relative;
          }
        }
      }
    }
    .table.b-table > thead > tr > th.sorting::before,
    table.b-table > tfoot > tr > th.sorting::before {
      right: unset;
      left: 1.5em;
      top: 10px;
    }
    .table.b-table > thead > tr > th.sorting::after,
    table.b-table > tfoot > tr > th.sorting::after {
      right: unset;
      left: 1em;
      top: 10px;
    }
    table.b-table > thead > tr > th.sorting,
    table.b-table > tfoot > tr > th.sorting {
      padding-left: 2.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/datatable/DataTable.vue